<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Duyuru Listesi
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <a routerLink="/announcement-list/new" class="btn btn-success btn-pill btn-sm">
                    <i class="fa fa-plus marr10"></i>Yeni Duyuru Ekle
                </a>

            </div>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Duyuru başlığı</th>
                                <th>Durum</th>
                                <th>Geçerlilik tarihi</th>
                                <th>Oluşturulma tarihi</th>
                                <th class="text-right">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let announcement of announcementList; index as i;">
                                <td>{{i+1}}</td>
                                <td>{{announcement.title}}</td>
                                <td>{{getStatus(announcement.status)}}</td>
                                <td>{{announcement.validUntil}}</td>
                                <td>{{announcement.creationDate}}</td>
                                <td>
                                    <button class="btn btn-success mr-2"
                                        [routerLink]="['/announcement-list/detail/'+announcement.id]"><i
                                        class="fa fa-edit"></i>Düzenle</button>
                                        <button class="btn btn-primary mr-2" (click)="sendEmails(announcement.id)"><i
                                        class="fa fa-bolt"></i>Mail gönder</button>
                                    <button class="btn btn-danger mr-2" (click)="deleteAnnouncement(announcement.id)"><i
                                            class="fa fa-trash"></i>Sil</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>